import * as React from "react";
import { forwardRef } from "react";
const SvgCheckCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2.25, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-check-check-icon lucide-check-check", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18 6 7 17l-5-5" }), /* @__PURE__ */ React.createElement("path", { d: "m22 10-7.5 7.5L13 16" }));
const ForwardRef = forwardRef(SvgCheckCheck);
export default ForwardRef;
